angular.module('ApptBookApp').directive('appointmentBookPlaceholder', ['meevoDateFilterFilter', (meevoDateFilterFilter) => {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            filterDates: '<',
            isEmployeeView: '<',
            disableDateChange: '<',
        },
        templateUrl: 'app/plugins/AppointmentBook/views/directives/AppointmentBookPlaceholder.html',
        link: (scope: any) => {
            scope.startDate = null;
            scope.endDate = null;

            scope.$watch('filterDates', filterDates => {
                if (!filterDates || filterDates.length < 1) {
                    return;
                }

                let startDate = filterDates[0];
                scope.startDate = meevoDateFilterFilter(moment(startDate).toDate());
                
                if (filterDates.length > 1) {
                    let endDate = filterDates[filterDates.length - 1];
                    scope.endDate = meevoDateFilterFilter(moment(endDate).toDate());
                } else {
                    scope.endDate = null;
                }
            });
        }
    };
}]);